import React from "react";
import PropTypes from "prop-types";

import DisabledOverlay from "../grundelemente/DisabledOverlay";

import ApplyDismiss from "./ApplyDismiss";
import RadioControl, { RadioOption } from "./RadioControl";
import { saveSettings } from "./SaveSettings";
import SelectControl, { SelectOptionDirect } from "./SelectControl";
import { isOk, stateFromModel, modelFromLocal, changeState, recheckState,
	validateNumber } from "./SettingsValue";
import StringControlWithUnitContainer from "./StringControlWithUnitContainer";

import "./Einheiten.css";

const default_local = {
	pressure: null,
	temperature: null,
	volume: null,
	currency: null,
	electricity_rate: null,
	electricity_co2_equivalent: null,
	oil_price: null,
	oil_heating_value: null,
	oil_co2_equivalent: null,
	gas_price: null,
	gas_heating_value: null,
	gas_co2_equivalent: null
};

class Einheiten extends React.Component {

	static propTypes = {
		units: PropTypes.object.isRequired,
		auth: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.apply = this.apply.bind(this);
		this.dismiss = this.dismiss.bind(this);
		this.state = this.genState();
	}
	genState() { return stateFromModel(default_local, this.props.units, Einheiten.validate); }
	apply() {
		let value = modelFromLocal(this.state.local);
		saveSettings("units", value);
	}
	dismiss() {
		this.setState(this.genState());
	}
	static validate(local) {
		const number_props = [ "electricity_rate", "electricity_co2_equivalent",
			"oil_price", "oil_heating_value", "oil_co2_equivalent", "gas_price",
			"gas_heating_value", "gas_co2_equivalent" ];
		for (let prop of number_props) {
			if (!isOk(validateNumber(local, prop))) {
				return false;
			}
		}
		return true;
	}
	handleChange(e) {
		this.setState(changeState(e.target.name, e.target.value, this.state, Einheiten.validate));
	}
	componentWillReceiveProps(nextProps) {
		let change = recheckState(this.state, nextProps.units, Einheiten.validate);
		if (change) {
			this.setState(change);
		}
	}
	render() {
		return (
			<div className="Einheiten">
				<DisabledOverlay disabled={!this.props.auth.canWrite} />
				<div className="Parameter">
					<form>
						<RadioControl i18n_key="Pressure" prop="pressure" local={this.state.local}>
							<RadioOption i18n_key="bar" prop="pressure" value="bar"
								local={this.state.local} handleChange={this.handleChange} />
							<RadioOption i18n_key="psi" prop="pressure" value="psi"
								local={this.state.local} handleChange={this.handleChange} />
							<RadioOption i18n_key="MPa" prop="pressure" value="MPa"
								local={this.state.local} handleChange={this.handleChange} />
						</RadioControl>
						<RadioControl i18n_key="Temperature" prop="temperature" local={this.state.local}>
							<RadioOption i18n_key="°C" prop="temperature" value="degC"
								local={this.state.local} handleChange={this.handleChange} />
							<RadioOption i18n_key="°F" prop="temperature" value="degF"
								local={this.state.local} handleChange={this.handleChange} />
							<RadioOption i18n_key="K" prop="temperature" value="degK"
								local={this.state.local} handleChange={this.handleChange} />
						</RadioControl>
						<RadioControl i18n_key="Volume" prop="volume" local={this.state.local}>
							<RadioOption i18n_key="m³" prop="volume" value="m3"
								local={this.state.local} handleChange={this.handleChange} />
							<RadioOption i18n_key="cft" prop="volume" value="cft"
								local={this.state.local} handleChange={this.handleChange} />
						</RadioControl>
						<SelectControl i18n_key="Currency" prop="currency"
							local={this.state.local} handleChange={this.handleChange}>
							<SelectOptionDirect value="EUR" />
							<SelectOptionDirect value="USD" />
						</SelectControl>
						<StringControlWithUnitContainer i18n_key="Electricity rate" prop="electricity_rate" unit_key="currency_over_energy"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="CO² equivalent current" prop="electricity_co2_equivalent" unit_key="kg_over_kWh"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="Oil price" prop="oil_price" unit_key="currency_over_l"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="Heating value oil" prop="oil_heating_value" unit_key="kWh_over_l"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="CO² equivalent oil" prop="oil_co2_equivalent" unit_key="kg_over_l"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="Gas price" prop="gas_price" unit_key="currency_over_volume"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="Heating value gas" prop="gas_heating_value" unit_key="energy_over_volume"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
						<StringControlWithUnitContainer i18n_key="CO² equivalent Gas" prop="gas_co2_equivalent" unit_key="mass_over_volume"
							validate={validateNumber} local={this.state.local} handleChange={this.handleChange} />
					</form>
				</div>
				<ApplyDismiss state={this.state} apply={this.apply} dismiss={this.dismiss} />
			</div>
		);
	}
}

export default Einheiten;
